import React, { useEffect } from 'react';
import { CheckCircle, XCircle, X } from 'lucide-react';
import './Notification.css';

const Notification = ({ 
  show, 
  type = 'success', 
  title, 
  message, 
  onClose, 
  autoClose = true, 
  duration = 6000 
}) => {
  useEffect(() => {
    if (show && autoClose) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [show, autoClose, duration, onClose]);

  if (!show) return null;

  const icons = {
    success: <CheckCircle size={24} />,
    error: <XCircle size={24} />
  };

  return (
    <div className="notification-overlay">
      <div className={`notification notification-${type}`}>
        <div className="notification-content">
          <div className="notification-icon">
            {icons[type]}
          </div>
          <div className="notification-text">
            <h3 className="notification-title">{title}</h3>
            <p className="notification-message">{message}</p>
          </div>
          <button 
            onClick={onClose}
            className="notification-close"
            aria-label="Fermer"
          >
            <X size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Notification;


